import React, { useState, useEffect } from 'react'
import moment from "moment";
import Select from 'react-select';
import { Button } from 'react-bootstrap';
import { FaCheck } from "react-icons/fa";

import { getFromApi } from '../utilities/NetUtilities';
import { buildUrl } from '../helper/handler';

function FiltriReport({ setMessage, onChange }) {

    const getStartOfYear = () => {
        return moment().startOf('year').format("YYYY-MM-DD");
    }

    const [inizio, setInizio] = useState(getStartOfYear());
    const [fine, setFine] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [sede, setSede] = useState(null);
    const [servizio, setServizio] = useState(null);
    const [lavoratore, setLavoratore] = useState(null);

    const [lavoratori, setLavoratori] = useState([]);
    const [sedi, setSedi] = useState([]);
    const [servizi, setServizi] = useState([]);

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setLavoratoriFromApi = (data) => {
            setLavoratori(data.lavoratori.map(lavoratore => ({
                "value": lavoratore.id,
                "label": lavoratore.nomeCognome
            })));
        }
        const setSediFromApi = (data) => {
            setSedi(data.sedi.map(sede => ({
                "value": sede.id,
                "label": sede.descrizione
            })));
        }
        const setServiziFromApi = (data) => {
            const servizi = data.servizi;
            const options = Object.keys(servizi).map(key => ({
                value: key,
                label: servizi[key][0]
            }));
            setServizi(options);
        };
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
        }
        if (organizzazioneMap) {
            const urlLavoratori = buildUrl('lavoratori', {
                organizzazione: organizzazioneMap.nome,
                tipo: organizzazioneMap.tipo
            });
            getFromApi(urlLavoratori, setLavoratoriFromApi, setMessageFromApi);
            getFromApi(buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setSediFromApi, setMessageFromApi);
            getFromApi(buildUrl('servizi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setServiziFromApi, setMessageFromApi);
        }
    }, [setMessage]);

    function checkInizioFine(inizio, fine) {
        const ok = inizio < fine;
        setMessage(ok ? [] : [{
            tipo: "danger",
            descrizione: "la data d'inizio deve essere antecedente a quella di fine"
        }]);
        return ok;
    }

    function inizioChanged(event) {
        const dataInizio = event.target.value;
        setInizio(dataInizio);
        checkInizioFine(dataInizio, fine);
    }

    const fineChanged = (event) => {
        const dataFine = event.target.value;
        setFine(dataFine);
        checkInizioFine(inizio, dataFine);
    }

    const applyFilter = () => {
        if (checkInizioFine(inizio, fine)) {
            onChange({
                inizio: inizio,
                fine: fine,
                sede: sede?.value,
                servizio: servizio?.value,
                lavoratore: lavoratore?.value
            })
        }
    }

    return (
        <div>
            <div className="row d-flex justify-content-center">
                <div className="col-lg-2 col-md-2">
                    <label htmlFor="inizio" className="inEvidenza">data inizio</label>
                    <input
                        className='form-control'
                        id="inizio"
                        type="date"
                        value={inizio}
                        onChange={inizioChanged}
                    />
                </div>
                <div className="col-lg-2 col-md-2">
                    <label htmlFor="fine" className="inEvidenza">data fine</label>
                    <input
                        className='form-control'
                        id="fine"
                        type="date"
                        value={fine}
                        onChange={fineChanged}
                    />
                </div>
                <div className="col-lg-2 col-md-2">
                    <label htmlFor="lavoratore" className="inEvidenza">lavoratore</label>
                    <Select
                        name="lavoratore"
                        instanceId="lavoratore"
                        options={lavoratori}
                        value={lavoratore}
                        onChange={setLavoratore}
                        placeholder="seleziona..."
                        isClearable
                    />
                </div>
                <div className="col-lg-2 col-md-2">
                    <label htmlFor="sede" className="inEvidenza" id="sede">sede</label>
                    <Select
                        name="sede"
                        instanceId="sede"
                        options={sedi}
                        value={sede}
                        onChange={setSede}
                        placeholder="seleziona..."
                        isClearable
                    />
                </div>
                <div className="col-lg-2 col-md-2">
                    <label htmlFor="servizio" className="inEvidenza">servizio</label>
                    <Select
                        name="servizio"
                        instanceId="servizio"
                        options={servizi}
                        value={servizio}
                        onChange={setServizio}
                        placeholder="seleziona..."
                        isClearable
                    />
                </div>
            </div>
            <div className="text-center mt-3">
                <Button
                    className="btn btn-sm"
                    onClick={applyFilter}
                    id="genera-report"
                    title="Genera Report"><FaCheck /></Button>
            </div>
        </div>
    )
}

export default FiltriReport;
